import { MutationTree } from 'vuex'
import { LocalStateInterface } from './state'
import { AssetUrl } from 'able-lib'
import { setProp } from 'src/lib/helper'
import { EventBus } from 'src/lib/eventBus'

const mutation: MutationTree<LocalStateInterface> = {
  updateDownloadAsset (state: LocalStateInterface, assetUrls: Array<{ id: number; url: Array<AssetUrl>}>) {
    // console.debug('updateDownloadAsset', assetUrls)
    state.downloadAssets.assetUrls = assetUrls
  },

  updateCurrentDownloadingAsset (state: LocalStateInterface, assetUrls: Array<AssetUrl>) {
    console.log('updateCurrentDownloadingAsset', assetUrls)
    state.downloadAssets.current = assetUrls
  },

  updateDownloadAssetProgress (state: LocalStateInterface, downloadProgress) {
    const { error, attempt } = downloadProgress
    if (error) {
      state.downloadAssets.currentDownloading = Object.assign(
        {}, state.downloadAssets.currentDownloading,
        {
          error,
          attempt
        }
      )
    } else state.downloadAssets.currentDownloading = downloadProgress
  },

  incrementCompletedDownloadedAsset (state: LocalStateInterface, assetUrl: AssetUrl) {
    const urls = state.downloadAssets.assetUrls.map(item => item.url)
    const download = urls.concat.apply([], urls)
    if (state.downloadAssets.completed < download.length) {
      state.downloadAssets.downloaded.push(assetUrl)
      state.downloadAssets.completed++
      EventBus.$emit('videoReady', assetUrl)
    }
  },

  SET_MAINTENANCE_INFO (state: LocalStateInterface, info = { effective_date: '', message: '', effective_state: false }) {
    state.maintenanceInfo = info
  },

  SET_MENU_PROPS (state: LocalStateInterface, { path, value }) {
    setProp(state.menus, path, value)
  },

  SET_ANSWERED_ASSIGNMENT_COUNT (state: LocalStateInterface, answered) {
    state.assignments.answered = answered
  },

  SET_UNANSWERED_ASSIGNMENT_COUNT (state: LocalStateInterface, unanswered) {
    state.assignments.unanswered = unanswered
  },

  SET_TOTAL_ASSIGNMENT_COUNT (state: LocalStateInterface, total) {
    state.assignments.total = total
  },

  SET_CURRENT_YEAR (state: LocalStateInterface, currentYear) {
    state.currentYear = currentYear
  },

  SET_ROLES (state: LocalStateInterface, roles) {
    state.roles = roles
  },

  SET_LEVELS (state: LocalStateInterface, levels) {
    state.levels = levels
  },

  SET_SUBJECTS (state: LocalStateInterface, subjects) {
    state.subjects = subjects
  },

  SET_LOCATIONS (state: LocalStateInterface, locations) {
    state.locations = locations
  }
}

export default mutation
